import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ArgentoHomeSection = () => (
  <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16 bg-secondary/40" data-testid="argento-home-section">
    <div className="max-w-container mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="lg:col-span-6 flex justify-center lg:justify-start">
        <div className="image-shine w-full aspect-[3/2] overflow-hidden rounded-2xl">
          <img
            src="/amira-collezione.jpg"
            alt="Collezione Amira — collana e bracciale tennis, Ciro Gallotti"
            className="w-full h-full object-cover"
            loading="lazy"
            data-testid="argento-home-image"
          />
        </div>
      </div>
      <div className="lg:col-span-6">
        <p className="text-eyebrow text-bordeaux mb-4" data-testid="argento-home-eyebrow">Collezione Amira</p>
        <h2 className="font-display text-h1 text-ink leading-tight mb-6">
          La luce <span className="italic">dell’argento</span>
        </h2>
        <p className="text-ink/70 leading-relaxed mb-10 max-w-md">
          Collane e bracciali in argento 925, lavorati a mano nei nostri laboratori di Napoli.
          Disponibili in tutte le misure, per un gioiello che veste alla perfezione.
        </p>
        <Link to="/argento" data-testid="argento-home-cta">
          <Button size="xl" variant="accent" className="group">
            Scopri l’Argento
            <ArrowRight className="w-4 h-4 ml-1 transition-transform duration-hover group-hover:translate-x-1" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);
